import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/** Route guard: blocks children until the boot refresh settles; bounces to /login. */
export function RequireAuth() {
  const { t } = useTranslation();
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'booting') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }} className="text-secondary">
        {t('common.loading')}
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
